export default {
    INCLUIR: 1,
    NAO_INCLUIR: 2,
    MOSTRAR_EXCLUSIVAMENTE: 3,
}
